import React from 'react';

import styled from 'styled-components';

import { CommunityIncentiveType } from 'types/incentives';

import { LIVING_TYPES_LABELS } from '../../../constants/livingTypes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: var(--font-regular);
  color: var(--text-secondary);
  font-size: 12px;
  line-height: normal;
`;

const Text = styled.div`
  color: var(--text-primary);
  font-size: 12px;
`;

type Props = {
  item: CommunityIncentiveType;
};

const CommunityIncentivesTableIncentivesCareType = ({ item }: Props) => {
  return (
    <Container>
      {item.living_types.map((livingType) => (
        <Text key={livingType}>{LIVING_TYPES_LABELS[livingType]}</Text>
      ))}
    </Container>
  );
};

export default CommunityIncentivesTableIncentivesCareType;
